export default __webpack_public_path__ + "static/media/musicBikram.774b8cf6.jpg";